import Header from '../components/Header';
import Loading from '../components/Loading';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMonster } from '../store/monster/action';
import { useEffect } from 'react';


const Monster = () => {
  const message = 'Monster Detail'

  const { monster, isLoading } = useSelector(state => {
    return state.monster
  })
  const dispatch = useDispatch()

  const { id } = useParams()

  useEffect(() => {
    dispatch(fetchMonster(id))
  }, [])

  return (
    <>
      <div
        className="
          flex
          flex-col
          min-h-screen
          items-center"
      >
        <Header msg={message} />
        <section
          className="
            flex-col
            justify-center
            items-center
            w-full
            bg-transparent"
        >

          {
            isLoading ? <Loading /> : (
              <div className="mx-6 rounded-lg md:flex  bg-gray-200 bg-opacity-90 h-1/2 lg:mt-16 xl:mt-16 2xl:mx-48 2xl:mt-36">
                <div className="rounded-t-lg  md:justify-center md:items-center md:w-6/12 lg:w-5/12 xl:w-4/12 2xl:w-3/12">
                  {
                    monster.card_images && (
                        <img className="md:h-full md:w-full md:rounded-bl-lg md:rounded-tr-none rounded-t-lg" src={monster.card_images[0].image_url} />
                    )
                  }
                </div>
                <div className="p-2.5 text-lg md:flex-1">
                  <div className="flex">
                    <p className="m-1">Name :</p>
                    <p className="flex-1 m-1 font-medium">{ monster.name }</p>
                  </div>
                  <div className="flex">
                    <p className="m-1">Level :</p>
                    <p className="flex-1 m-1">{ monster.level }</p>
                  </div>
                  <div className="flex">
                    <p className="m-1">Attribute :</p>
                    <p className="flex-1 m-1">{ monster.attribute }</p>
                  </div>
                  <div className="flex">
                    <p className="m-1">Race :</p>
                    <p className="flex-1 m-1">{ monster.race }</p>
                  </div>
                  <div className="flex">
                    <p className="m-1">Atk :</p>
                    <p className="flex-1 m-1">{ monster.atk }</p>
                  </div>
                  <div className="flex">
                    <p className="m-1">Def :</p>
                    <p className="flex-1 m-1">{ monster.def }</p>
                  </div>
                  <div className="flex">
                    <p className="m-1">Type :</p>
                    <p className="flex-1 m-1">{ monster.type }</p>
                  </div>
                  <div className="flex">
                  {
                    monster.type === 'Effect Monster' ? (
                      <p className="m-1">Effect :</p>
                      ) : (
                      <p className="m-1">Desc :</p>
                      )
                  }
                    <p className="flex-1 m-1 text-justify">{ monster.desc }</p>
                  </div>
                </div>
              </div>
            )
          }
        </section>
      </div>
    </>
  )
}

export default Monster